import { useEffect, useState } from 'react';
import client from 'utils/Api';

const useVerifyPurchase = (id, refreshFlag) => {
  const [purchase, setPurchase] = useState({
    data: {
      lightning_invoice: {
        payreq: undefined,
      },
    },
  });

  async function getPurchase() {
    if (id) {
      try {
        const axiosClient = client();
        const response = await axiosClient.get(`/purchases/${id}`);
        if (response?.data?.localPurchases?.length > 0)
          setPurchase((prevState) => ({ ...prevState, data: { ...response.data }, localPurchases: [...response.data.localPurchases] }));
        else
          setPurchase((prevState) => ({ ...prevState, data: { ...response.data }, localPurchases: null }));
      } catch (error) {
        console.error(error);
      }
    }
  }

  useEffect(() => {
    getPurchase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, refreshFlag]);

  return purchase;
};

export default useVerifyPurchase;
